import { NOTIF_SERVICE_SEGMENT } from "@config/apiConfig";
import { api } from "@services/api";
import type {
  GetNotificationsParams,
  GetUnseenParams,
  MarkSeenParams,
  NotificationsApiResponse,
} from "@services/notifications/types.ts";

export const getNotifications = async ({
  service,
  page = 0,
  size = 25,
  checkUserSession = false,
}: GetNotificationsParams): Promise<NotificationsApiResponse> => {
  return api.get<NotificationsApiResponse>(
    service,
    `notification?pageNumber=${page}&pageSize=${size}${checkUserSession ? "&checkUserSession=true" : ""}`,
  );
};

// @TODO -To be implemented, do not delete yet
export async function getUnseenNotifications({
  service = NOTIF_SERVICE_SEGMENT,
  page = 0,
  size = 25,
}: GetUnseenParams): Promise<NotificationsApiResponse> {
  return api.get<NotificationsApiResponse>(
    service,
    `notification/unseen?pageNumber=${page}&pageSize=${size}`,
  );
}

// @TODO -To be implemented, do not delete yet
export async function markNotificationsSeen({
  service = NOTIF_SERVICE_SEGMENT,
  ids,
  transactionId,
}: MarkSeenParams & { transactionId?: string }) {
  return api.post<void>(
    service,
    "notification/seen",
    ids,
    ...(transactionId ? [{ transactionId }] : []),
  );
}
